"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeValuedLogic = void 0;
var ThreeValuedLogic = /** @class */ (function () {
    function ThreeValuedLogic() {
    }
    ThreeValuedLogic.and = function () {
        var val = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            val[_i] = arguments[_i];
        }
        if (val.includes(false)) {
            return false;
        }
        else if (val.includes(null)) {
            return null;
        }
        else {
            return true;
        }
    };
    ThreeValuedLogic.or = function () {
        var val = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            val[_i] = arguments[_i];
        }
        if (val.includes(true)) {
            return true;
        }
        else if (val.includes(null)) {
            return null;
        }
        else {
            return false;
        }
    };
    ThreeValuedLogic.xor = function () {
        var val = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            val[_i] = arguments[_i];
        }
        if (val.includes(null)) {
            return null;
        }
        else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return val.reduce(function (a, b) { return (!a ^ !b) === 1; });
        }
    };
    ThreeValuedLogic.not = function (val) {
        if (val != null) {
            return !val;
        }
        else {
            return null;
        }
    };
    return ThreeValuedLogic;
}());
exports.ThreeValuedLogic = ThreeValuedLogic;
//# sourceMappingURL=logic.js.map